<script setup>
import { useI18n } from 'vue-i18n';
import SystemAssistantCard from './components/SystemAssistantCard.vue';
const { t } = useI18n();
</script>

<template>
  <div class="w-full">
    <header class="mb-5">
      <p class="text-sm text-n-slate-11">{{ t('AI_CONFIG.MODULE') }}</p>
      <h1 class="text-xl font-semibold text-n-slate-12 mt-3">
        {{ t('AI_CONFIG.USAGE_MENU') }}
      </h1>
      <p class="text-sm text-n-slate-11 mt-2">
        {{ t('AI_CONFIG.USAGE_DESCRIPTION') }}
      </p>
    </header>
    <SystemAssistantCard usage-only />
  </div>
</template>
